import { useBrand } from '../lib/brand';

/**
 * The brand picker at the top of the sidebar. On a brand screen it moves to the same screen for
 * the new brand; elsewhere it changes which brand the sidebar links and next screens use.
 */
export function BrandSwitcher() {
  const { brands, brand, setBrandId, loading } = useBrand();
  if (!brands.length) {
    return (
      <div className="switch">
        <label className="sel">
          <select aria-label="Brand" disabled value="">
            <option value="">{loading ? 'Loading brands…' : 'No brands yet'}</option>
          </select>
        </label>
        {!loading ? <small>The owner adds brands in Settings.</small> : null}
      </div>
    );
  }
  return (
    <div className="switch">
      <label className="sel">
        <select aria-label="Brand" value={brand?.id ?? ''} onChange={(e) => e.target.value && setBrandId(e.target.value)}>
          {!brand ? (
            <option value="" disabled>
              Pick a brand
            </option>
          ) : null}
          {brands.map((b) => (
            <option key={b.id} value={b.id}>
              {b.name}
            </option>
          ))}
        </select>
      </label>
      {brand ? <small title={brand.domain}>{brand.domain}</small> : null}
    </div>
  );
}
